import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
export function CountdownTimer() {
  // Set initial time to 23:59:33
  const [timeLeft, setTimeLeft] = useState(23 * 3600 + 59 * 60 + 33);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  // Progress bar: percentage of time elapsed (starts full, drains to 0)
  const totalTime = 24 * 3600;
  const progressPercent = Math.round((1 - timeLeft / totalTime) * 100);
  return <div className="py-10 px-4 text-center" data-id="element-112">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className="max-w-lg mx-auto" data-id="element-113">
        {/* Header */}
        <h3 className="text-2xl md:text-3xl font-bold text-white mb-8 uppercase tracking-wide" data-id="element-114">
          ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
        </h3>

        {/* Countdown Numbers */}
        <div className="flex justify-center items-baseline gap-1 md:gap-2 mb-8" data-id="element-115">
          <div className="text-center" data-id="element-116">
            <span className="text-6xl md:text-8xl font-bold text-red-500 font-mono tabular-nums" data-id="element-117">
              {formatTime(hours)}
            </span>
            <span className="block text-sm md:text-base text-gray-400 uppercase mt-2 font-sans tracking-widest" data-id="element-118">
              HS
            </span>
          </div>
          <span className="text-5xl md:text-7xl font-bold text-red-500 font-mono pb-6" data-id="element-119">
            :
          </span>
          <div className="text-center" data-id="element-120">
            <span className="text-6xl md:text-8xl font-bold text-red-500 font-mono tabular-nums" data-id="element-121">
              {formatTime(minutes)}
            </span>
            <span className="block text-sm md:text-base text-gray-400 uppercase mt-2 font-sans tracking-widest" data-id="element-122">
              MIN
            </span>
          </div>
          <span className="text-5xl md:text-7xl font-bold text-red-500 font-mono pb-6" data-id="element-123">
            :
          </span>
          <div className="text-center" data-id="element-124">
            <span className="text-6xl md:text-8xl font-bold text-red-500 font-mono tabular-nums" data-id="element-125">
              {formatTime(seconds)}
            </span>
            <span className="block text-sm md:text-base text-gray-400 uppercase mt-2 font-sans tracking-widest" data-id="element-126">
              SEG
            </span>
          </div>
        </div>

        {/* Warning text */}
        <div className="flex items-center justify-center gap-2 mb-10" data-id="element-127">
          <AlertTriangle className="w-6 h-6 text-yellow-400" data-id="element-128" />
          <p className="text-lg md:text-xl text-white font-medium" data-id="element-129">
            Después sube{' '}
            <span className="text-red-500 font-bold" data-id="element-130">$10.000 ARS</span> y no
            vuelve a bajar.
          </p>
        </div>

        {/* Cupos progress bar */}
        <div className="max-w-md mx-auto" data-id="element-131">
          <div className="flex justify-between items-center mb-2" data-id="element-132">
            <span className="text-red-400 font-semibold flex items-center gap-2" data-id="element-133">
              🔴 Cupos al precio de lanzamiento
            </span>
            <span className="text-white font-bold text-sm" data-id="element-134">Quedan pocos</span>
          </div>
          <div className="w-full h-3 bg-gray-700 rounded-full overflow-hidden" data-id="element-135">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: `${Math.min(71 + progressPercent * 0.2, 95)}%`
          }} viewport={{
            once: true
          }} transition={{
            duration: 1.5,
            ease: 'easeOut'
          }} className="h-full rounded-full bg-gradient-to-r from-red-600 via-orange-500 to-yellow-500" data-id="element-136" />
          </div>
          <p className="text-gray-400 text-sm mt-2" data-id="element-137">71% de los cupos tomados</p>
        </div>
      </motion.div>
    </div>;
}